import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';
import { ServerBaseService } from '../server-base.service';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { SupplierPreference } from '@equipmyschool/emsadminweb-models';

@Injectable({
  providedIn: 'root'
})
export class SupplierPreferenceService extends ServerBaseService {
  private _id$ = new BehaviorSubject<number>(null);
  public id$ = this._id$.asObservable();
  private _supplierPreferences$ = new BehaviorSubject<SupplierPreference[]>([]);
  private supplierPreferences$ = this._supplierPreferences$.asObservable();

  public supplierPreference$: Observable<SupplierPreference> =
    combineLatest([this.supplierPreferences$, this.id$]).pipe(map(
      ([supplierPreferences, id]) => supplierPreferences.find(supplierPreference => supplierPreference.SupplierPreferenceID == id)
    ));

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl);

    this.request<SupplierPreference[]>('GET', 'SupplierPreference/Get').subscribe({
      next: (supplierPreferences => this._supplierPreferences$.next(supplierPreferences))
    });
  }

  public getSupplierPreference(Id: number) {
    this._id$.next(Id);
  }
}
